import { useState } from 'react'

import { meetingApi, RegisterParticipantsRequest } from '../api'

export const useRegisterParticipants = () => {
  const [isRegistering, setIsRegistering] = useState(false)

  const registerParticipants = async (
    meetingId: string,
    participants: RegisterParticipantsRequest,
  ) => {
    setIsRegistering(true)

    try {
      const meeting = await meetingApi.registerParticipants(meetingId, participants)
      return meeting
    } catch (error) {
      console.error('Failed to register participants', error)
    } finally {
      setIsRegistering(false)
    }
  }

  return { isRegistering, registerParticipants }
}

export default useRegisterParticipants
